import { TimeUtils } from '@colonist/utils';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { showRequestPushNotificationDialog } from '../ui_popup/showRequestPushNotificationDialog.ts';
import { UIDeviceController } from '../../../shared/scripts/ui_html/UIDeviceController.ts';
import { UIEntryUrlParameterController } from '../../../shared/scripts/UIEntryUrlParameterController.ts';
export const USER_ACTION_ENUM = {
    USER_REJECTED_PUSH_NOTIFICATION: 0,
    USER_ACCEPTED_PUSH_NOTIFICATION: 1
};
export var PushNotificationPopupIntentEnum = /*#__PURE__*/ function(PushNotificationPopupIntentEnum) {
    PushNotificationPopupIntentEnum["OnLoadHomePage"] = "ON_LOAD_HOME_PAGE";
    PushNotificationPopupIntentEnum["OnUserSentFriendRequest"] = "ON_USER_SENT_FRIEND_REQUEST";
    return PushNotificationPopupIntentEnum;
}({});
export const pushNotificationPopupData = [
    {
        intent: "ON_LOAD_HOME_PAGE",
        frequency: TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY * TimeUtils.DAYS_IN_WEEK,
        showNotificationPopup: ()=>{
            if (UIEntryUrlParameterController.suppressPopupsOnLoad == true) return;
            showRequestPushNotificationDialog("ON_LOAD_HOME_PAGE");
        }
    },
    {
        intent: "ON_USER_SENT_FRIEND_REQUEST",
        frequency: TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY,
        showNotificationPopup: ()=>showRequestPushNotificationDialog("ON_USER_SENT_FRIEND_REQUEST")
    }
];
export class UIMRequestPushNotificationController {
    static showRequestPushNotification(intent) {
        if (!this.shouldRequestPushNotification(intent)) return;
        this.updateTimestampData(intent);
        const popupType = pushNotificationPopupData.find((popup)=>popup.intent === intent);
        if (!popupType) return;
        popupType.showNotificationPopup();
    }
    static updateTimestampData(intent) {
        const timestampData = StorageWrapper.getRequestPushNotificationTimeData();
        const newTimestampData = {
            ...timestampData,
            [intent]: new Date()
        };
        StorageWrapper.setRequestPushNotificationTimeData(newTimestampData);
    }
    static shouldRequestPushNotification(intent) {
        var _ClientUserState_userState;
        if (UIDeviceController.isUserOnMobileWebBrowser()) return false;
        const hasUserBypassedLogin = StorageWrapper.getIfUserBypassedLogin();
        const isUserLoggedIn = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn;
        if (!hasUserBypassedLogin && !isUserLoggedIn) return false;
        const hasUserAcceptedPushNotification = StorageWrapper.getPushNotificationRequestStatus();
        if (hasUserAcceptedPushNotification) return false;
        const hasUserBeenPromptedRecentlyForSameIntent = this.hasUserBeenPromptedRecentlyForSameIntent(intent);
        if (hasUserBeenPromptedRecentlyForSameIntent) return false;
        const hasUserBeenPromptedRecently = this.hasUserBeenPromptedRecently();
        if (hasUserBeenPromptedRecently) return false;
        return true;
    }
    static getLatestPopupTimestamp() {
        const allTimestamps = Object.values(StorageWrapper.getRequestPushNotificationTimeData()).filter((date)=>date != null).map((date)=>new Date(date).valueOf());
        if (allTimestamps.length == 0) return 0;
        return Math.max(...allTimestamps);
    }
    static hasUserBeenPromptedRecentlyForSameIntent(intent) {
        var _pushNotificationPopupData_find;
        const timestampData = StorageWrapper.getRequestPushNotificationTimeData();
        const lastRequestPushNotificationTime = timestampData[intent];
        if (lastRequestPushNotificationTime == null) return false;
        const frequency = (_pushNotificationPopupData_find = pushNotificationPopupData.find((popup)=>popup.intent === intent)) === null || _pushNotificationPopupData_find === void 0 ? void 0 : _pushNotificationPopupData_find.frequency;
        if (frequency == undefined) return false;
        return new Date().valueOf() - new Date(lastRequestPushNotificationTime).valueOf() < frequency;
    }
    static hasUserBeenPromptedRecently() {
        const latestPopupTimestamp = this.getLatestPopupTimestamp();
        if (latestPopupTimestamp == 0) return false;
        const minimumGapBetweenAnyPopups = TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY;
        return new Date().valueOf() - latestPopupTimestamp < minimumGapBetweenAnyPopups;
    }
}
